import { BalanceAction } from "../Balance.types";

export const ACTION_LABEL: Record<BalanceAction, string> = {
    add: "+",
    subtract: "-",
    display: "",
    round: "≈ ",
    less: "< ",
};
